export const IsEmptyOrNull = function(value) {
    if (value === null || value === '' || typeof value === 'undefined') {
        return true
    }
    return false
}

export const ContainsFiles = function (event) {
  if (event.dataTransfer.types) {
    for (var i = 0; i < event.dataTransfer.types.length; i++) {
      if (event.dataTransfer.types[i] === 'Files') {
        return true
      }
    }
  } else {
    if (event.dataTransfer.files.length > 0) {
        return true
    }
  }
  return false
}

export const IsMobile = function () {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && ('ontouchstart' in window || navigator.maxTouchPoints)) {
    return true
  }
  else {
    return false
  }
}

export const GetOffsetHeightElem = function(selector) {
    var element = document.querySelector(selector)
    if (!IsEmptyOrNull(element)) {
        return element.offsetHeight
    }
}

export const Debounce = function(func, wait, immediate) {
    var timeout
    var args
    var context
    var timestamp
    var result

    var later = function() {
        var last = Now() - timestamp

        if (last < wait && last >= 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function() {
        context = this
        args = arguments
        timestamp = Now()
        var callNow = immediate && !timeout
        if (!timeout) {
            timeout = setTimeout(later, wait)
        }
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }
        return result
    }
}

export const Now = Date.now || function() {
    return new Date().getTime()
}

export const RecordAudio = () => new Promise(async resolve => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    const mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' })
    let audioChunks = []

    mediaRecorder.addEventListener('dataavailable', event => {
        audioChunks.push(event.data)
    })

    const start = () => {
        audioChunks = []
        mediaRecorder.start()
    }

    const stop = () =>
        new Promise(resolve => {
            mediaRecorder.addEventListener('stop', () => {
                const audioBlob = new Blob(audioChunks)
                const audioUrl = URL.createObjectURL(audioBlob)
                const audio = new Audio(audioUrl)
                const play = () => audio.play()
                resolve({ audioChunks, audioBlob, audioUrl, play })
            })
            mediaRecorder.stop()
        })

    resolve({ start, stop })
})